import ThemeRoutes from 'routes';
import NavigationScroll from 'layout/NavigationScroll';
import ThemeCustomization from 'themes';
import { I18nextProvider } from 'react-i18next';
import initializeI18n from 'utils/i18n';
import { useLanguage } from 'contexts/LanguageContext';
import { useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/system';
import Snackbar from 'ui-component/extended/Snackbar';
import { useSearchParams } from 'react-router-dom';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import axios from 'utils/axios';

const AppWeb = () => {
    const theme: any = useTheme();
    const [i18nInstance, setI18nInstance] = useState<any>(null);
    const { language } = useLanguage();
    const [query] = useSearchParams();

    const getCsrfToken = async () => {
        try {
            const fp = await FingerprintJS.load();
            const result = await fp.get();
            const fingerprint = result.visitorId;

            localStorage.setItem('fp_id', fingerprint);

            await axios({
                url: '/auth/_csurf',
                method: 'post',
                data: {
                    fingerprint
                },
                withCredentials: true
            });

            axios.defaults.headers.common['x-fingerprint-id'] = fingerprint || '';

            const res = await axios({
                url: '/auth/csrf-token',
                method: 'get',
                headers: {
                    'x-fingerprint-id': fingerprint
                },
                withCredentials: true
            });

            const { csrfToken } = res?.data;
            localStorage.setItem('csrf_token', csrfToken);
            axios.defaults.headers.common['x-csrf-token'] = csrfToken || '';
        } catch (error) {
            console.error('Error fetching CSRF token:', error);
        }
    };

    useEffect(() => {
        const initI18n = async () => {
            await getCsrfToken();
            setTimeout(async () => {
                const i18n = await initializeI18n();
                setI18nInstance(i18n); // Set the initialized i18n instance
            }, 1000)
        };

        initI18n();
    }, [language]);

    useEffect(() => {
        if (query) {
            const inviteCode = query.get("invite");
            if (inviteCode && process.env.REACT_APP_COOKIES_INVITE_CODE) {
                localStorage.setItem(process.env.REACT_APP_COOKIES_INVITE_CODE, inviteCode);
            }
        }
    }, [query]);

    const bgColor = theme?.customColors?.loaderBoxBgColor || '#128efbf4';
    const borderColor = theme?.customColors?.loaderBoxBorderColor || '#0373d4';


    if (!i18nInstance) {
        return (<Box maxWidth={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <div className='spinner'>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
                <div style={{ backgroundColor: bgColor, borderColor: borderColor }}></div>
            </div>
        </Box>);
    }
    return (<I18nextProvider i18n={i18nInstance}>
        <ThemeCustomization>
            <NavigationScroll>
                <><ThemeRoutes />
                    <Snackbar /></>
            </NavigationScroll>
        </ThemeCustomization>
    </I18nextProvider>);
};

export default AppWeb;
